<div class="homePageContainer">
    <img src="assets\Images\Frame 3 (2) 1.png" height="502" width="100%" class="responsive">
    
    <h3 class="text-center woundering_text"> Wondering what can we buy from India? Almost everything!!! </h3>

    <div class="slide_show_container">
        <div class="tech-slideshow">
            <div class="mover-1">
                <img src="assets\Images\Mask Group-1.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-2.png" class="slidehow_image">
                <img src="assets\Images\Mask Group.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-3.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-4.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-2.png" class="slidehow_image">
                <img src="assets\Images\Mask Group.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-3.png" class="slidehow_image">
                <img src="assets\Images\Mask Group-4.png" class="slidehow_image">
            </div>
            <div class="mover-2"></div>
        </div>
    </div>


    <div class="container-fluid">
        <h3 class="text-center some_indian_text"> Some Indian Online sites to shop from </h3>

        <div class="shoping_lists_container">

            <div class="shopping_list_info_container">
                <div class="shoping_list_info">
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.myntra.com"> 
                            <img src="assets\Images\Group 39.png" alt="" class="single_shop_image"> </a>
                    </div>
                    <div class="single_shop_list">
                       <a target="_blank" rel="noopener" href="https://www.amazon.com">
                        <img src="assets\Images\Group 40.png" alt="" class="single_shop_image">
                       </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.flipkart.com/">
                            <img src="assets\Images\Group 42.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.ajio.com">
                            <img src="assets\Images\Group 47.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.fabindia.com/">
                            <img src="assets\Images\Group 46.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                </div>
    
                <div class="shoping_list_info">
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.limeroad.com/">
                            <img src="assets\Images\Group 38.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.pepperfry.com/">
                            <img src="assets\Images\Group 41.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.nykaa.com/">
                            <img src="assets\Images\Group 43.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://paytmmall.com/">
                            <img src="assets\Images\Group 44.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                    <div class="single_shop_list">
                        <a target="_blank" rel="noopener" href="https://www.snapdeal.com/">
                            <img src="assets\Images\Group 45.png" alt="" class="single_shop_image">
                        </a>
                    </div>
                </div>
            </div>

            <div class="more_sites_container text-center">
                <button class="more_size_btn" (click)="moreAwesome()"> More Awesome Sites  </button>
            </div>

        </div>
    </div>




    <div class="door-step-bg">
        <div class="door_step_container">
            <div class="door_step_info text-white">
                <h6 class="text-center door_step_hindhi_title"> करे मुद्दे की बात? </h6>
                <h3 class="text-center doorstep_title"> How to get yourDesiCart @ Your Doorstep? </h3>
    
                <div class="container">
                    <div class="row">
                         <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_one">
                            <div class="text-center"> 
                                <div class="numberCircle">1</div>
                            </div>

                            <h6 class="circle_title"> Signup </h6>
    
                            <p class="door_step_para"> Get yourDesiCart India Locker
                                Address to store all your
                                shopping items. </p>
                         </div>
                         <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_two">
                            <div class="text-center"> 
                                <div class="numberCircle">2</div>
                            </div>

                            <h6 class="circle_title"> Shop </h6>
    
                            <p class="door_step_para"> 
                                Shop from any store in India & ship to your Locker. Get package picked up from friends/family in
                                India. Avail custom tailoring and other concierge services. </p>
                         </div>
                         <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_three">
                            <div class="text-center"> 
                                <div class="numberCircle">3</div>
                            </div>

                            <h6 class="circle_title"> Relax </h6>
    
                            <p class="door_step_para"> We will Track your Indian shopping orders, Inspect them, Consolidate
                                into one
                                package to save
                                costs and Ship them to your doorstep anywhere in the world. </p>
                         </div>
                         <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_four">
                            <div class="text-center"> 
                                <div class="numberCircle">4</div>
                            </div>

                            <h6 class="circle_title"> Receive </h6>
    
                            <p class="door_step_para"> Receive at your doorstep in 3-10 days. Enjoy yourDesiCart sitting
                                miles away
                                from
                                India ! </p>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="why_signup_container">
        <div class="why-signup-info">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                          <h3 class="why_header_title"> Why should you Signup </h3>

                          <div class="why_lists">
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Shop & Ship from India @ Low cost prices
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Indian stores not accepting payment methods
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Access to authentic wide ranging Indian goods
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Don't know from where to Shop, need recommendations?
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Get package Picked-up from anywhere in India
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   One-stop for all your Indian shopping needs
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   First hand access to skillful artisans, tailors, carpenters, designers, and many more
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Ability to inspect purchased items - near to real-life feedback
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Ability to return items in India if you dont like them
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Consolidation and safe packing of all of your purchases
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Excellent domestic and international courier tracking
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Get updated with trendy and latest styles in India
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Be the first to know latest deals in India
                                </p>
                              <p class="single_list">
                                   <img src="assets\Images\Grogggup.png" height="18" width="18" class="mr-2"> 
                                   Great customer service - hassle free shopping needs in India
                                </p>
                          </div>
                    </div>

                    <div class="col-md-6 col-lg-6 col-xl-6 text-center">
                        <img src="assets\Images\Mask gGroup.png" class="signup_image">
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <hr>

    <div class="refer_frnd_container">
        <div class="refer_frnd_info">
               <div class="container-fluid">
                   <div class="row">
                       <div class="col-md-6 col-lg-6 col-xl-4">
                           <div class="card">
                               <div class="card-header text-center bg-dark-refer">
                                <img src="assets\Images\Group.png">
                                <div class="refer_parent_para">
                                    <p class="refer_frnd_para"> REFER A FRIEND PROGRAM </p>
                                </div>
                               </div>

                               <div class="card-body">
                                   <p class="gopinath_text"> Hi Mr. Gopinath <br>
                                    Earn (Reward description) and also give your friends 
                                    (Offer description) when they use link to use services 
                                    from yourDesiCart! <br> <br>
                                    
                                    It’s super easy! </p>
                               </div>

                               <div class="card">
                                   <div class="card-header text-white bg-dark-refer">
                                       <h5 class="text-center share_title"> Share your referral link with friends </h5>

                                       <div class="share_parent_para text-center">
                                        <button class="share_frnd_btn"> (referral link url) </button>
                                    </div>
                                   </div>
                               </div>

                               <!-- <div class="card-body"> -->
                                   <p class="text-center share_social_para"> Or Share directly on social media </p>

                                   <div class="social_media_btn_container">
                                       <a class="fb_link"> Facebook </a>
                                       <a class="tw_link"> Twitter </a>
                                       <a class="wp_link"> Whatsapp </a>
                                   </div>

                                   <p class="find_out_text text-center"> How do I claim reward? <span> Click here </span> to find out </p>
                               <!-- </div> -->
                           </div>  
                           
                           
                       </div>

                       <div class="col-md-6 col-lg-6 col-xl-8">
                        <iframe title="Shop From India Ship Worldwide"
                        src="https://www.youtube.com/embed/fAFXkcxXPtQ?feature=oembed" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen="" class="fluidvids-item iframe_class" data-fluidvids="loaded">
                    </iframe>
                       </div>
                   </div>
               </div>
        </div> 
    </div>


    <div class="about_desi_cart-container">
         <div class="about-desi-info">
             <h3 class="about_desi_title text-center"> What is yourDesiCart </h3>

             <div class="container">
                 <div class="col-md-12 mx-auto">
                     <p class="what_desi_title"> 
                        yourDesiCart is your shopping friend from India, that facilitates shopping from India and shipping worldwide. It can facilitate shopping from online sites, local stores, 
                        vendors, package pickups. Either you can shop yourself and ship items to yourDesiCart India Locker or use yourDesiCart Personal Shoppers to shop on your behalf from India.
                        Shop & Ship anything from India.
                     </p>
                 </div>

                 <div class="desi_accordian_container">
                    <details id="desihover">
                        <summary>
                            <p><i class="fa fa-plus-circle" style="font-size: 23px;margin-right: 1rem;color: black;"></i> Do I Get A Locker In India To
                                Store My
                                Purchases?</p>
                        </summary>
                        <p id="innerhide">Yes, Signup and get yourDesiCart India Locker address to store items
                            purchased in India</p>
                    </details>
                    <hr>
                    <details id="desihover">
                        <summary>
                            <p><i class="fa fa-plus-circle" style="font-size: 23px;margin-right: 1rem;color: black;"></i> Dan You Manage My Online
                                Orders In
                                India?</p>
                        </summary>
                        <p id="innerhide">Yes, shop from anywhere in India and ship to yourDesiCart India Locker
                            address. We will
                            Track, Inspect, Consolidate, Pack & Ship to your doorstep worldwide.</p>
                    </details>
                    <hr>
                    <details id="desihover">
                        <summary>
                            <p><i class="fa fa-plus-circle" style="font-size: 23px;margin-right: 1rem;color: black;"></i> Can You Pickup Package From My
                                Home In
                                India?</p>
                        </summary>
                        <p id="innerhide">Absolutely yes! we can pickup package from your family, friends, vendor, store
                            etc. anywhere in India and ship it to yourDesiCart India Locker address for further perusal</p>
                    </details>
                    <hr>
                    <details id="desihover">
                        <summary>
                            <p><i class="fa fa-plus-circle" style="font-size: 23px;margin-right: 1rem;color: black;"></i> Can You Shop On My Behalf In
                                India?</p>
                        </summary>
                        <p id="innerhide">yourDesiCart Personal Shoppers can shop on your behalf from anywhere in India
                            and ship worldwide</p>
                    </details>
                    <hr>
                    <details id="desihover">
                        <summary>
                            <p><i class="fa fa-plus-circle" style="font-size: 23px;margin-right: 1rem;color: black;"></i> Can You Tailor-Make My
                                Garments, Customize Pooja Mandir, Tailor Make Cusrtains?</p>
                        </summary>
                        <p id="innerhide">We can facilitate anything in India and ship to you, just ask us !</p>
                    </details>
                 </div>
             </div>


         </div>
    </div>



    <div class="testmonial-bg">
        <div class="testimonial_container">
            <div class="testmonial_info">
                <h3 class="testimonial_title text-center"> What our customers say About us </h3>

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-lg-6 col-xl-4 test_one_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-xl-4 test_two_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-xl-4 test_three_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                    </div>


                    <div class="test_view_more_btn_container text-center">
                        <button class="test_view_more_btn" (click)="comment()"> View more </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <app-footer></app-footer>

</div>